import dayjs from "dayjs";
import { useRecordList } from "./RecordList.hook";
import { DailyReport } from "../../../lib/apollo/graphql/generated";
import ColoredLabel from "../../common/components/ColoredLabel";
import Table from "../../common/components/Table";

interface RecordListProps {
  onFetchMore: () => void;
  hasNextPage: boolean;
  loading: boolean;
  records?: DailyReport[];
}

export default function RecordList({
  onFetchMore,
  loading,
  hasNextPage,
  records,
}: RecordListProps) {
  const {
    models: { isFetchingMore },
    operations: { moveToDetailPage, onViewChange },
  } = useRecordList(onFetchMore, hasNextPage);

  return (
    <Table.Wrapper>
      <Table.Header
        tabs={[
          { label: "완료여부" },
          { label: "수급자" },
          { label: "보호사" },
          { label: "작성 시간" },
          { label: "삭제 시간" },
        ]}
      />
      <Table.Body
        isLoading={loading}
        isEmpty={!records?.length}
        infiniteScroll={{
          isFetchingMore,
          hasNextPage,
          onViewChange,
        }}
      >
        {records?.map((record) => (
          <Table.Row onClick={() => moveToDetailPage(record?.id)}>
            <Table.Column>
              <ColoredLabel
                text={!!record?.dailyReport ? "완료" : "미완료"}
                backgroundColor={!!record?.dailyReport ? "green" : "red"}
              />
            </Table.Column>
            <Table.Column>{record?.receiver?.name}</Table.Column>
            <Table.Column>{record?.caregiver?.name}</Table.Column>
            <Table.Column>
              {dayjs(record?.createdAt).format("YY.MM.DD HH:MM")}
            </Table.Column>
            <Table.Column>
              {record?.deletedAt
                ? dayjs(record.deletedAt).format("YY.MM.DD HH:MM")
                : "-"}
            </Table.Column>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Wrapper>
  );
}
